import { EquipamentoFilter } from '@/shared/models/equipamento/equipamento.filter';
import { EquipamentoInterface } from '@/shared/models/equipamento/equipamento.interface';

import queryUtil from '@/shared/utils/query.util';
import store from '@/store';
import { MapActionsSnackbarModule } from '@/store/snackbar/map-actions.snackbar';
import { instanciaAxios } from '@/services/base.service';
import { AxiosError, AxiosResponse } from 'axios';
import Format from '@/shared/utils/format.util';

const equipamento = 'equipamento';

function montaEndereco(eq: EquipamentoFilter): EquipamentoFilter {
  eq.endereco = `${eq.pais != null ? `${eq.pais} ,` : ''}
    ${eq.estado != null ? `${eq.estado},` : ''}
    ${eq.cidade != null ? `${eq.cidade},` : ''}
    ${eq.bairro != null ? `${eq.bairro},` : ''}
    ${eq.logradouro != null ? `${eq.logradouro} ,` : ''}
    ${eq.numero != null ? `${eq.numero}` : ''}`;
  return eq;
}

export default class EquipamentoService {
  async buscarPorId(id: number): Promise<EquipamentoInterface> | null {
    return await instanciaAxios.get(`${equipamento}/${id}`)
      .then((response: AxiosResponse<EquipamentoInterface>) => response.data)
      .catch((error: AxiosError) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        console.error(error);
        return null;
      });
  }

  async buscarTodos(): Promise<EquipamentoFilter[] | null> {
    return await instanciaAxios.get(equipamento)
      .then((response: AxiosResponse) => {
        const lista: Array<EquipamentoFilter> = response.data;
        return lista.map((eq) => montaEndereco(eq));
      })
      .catch((error: AxiosError) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        console.error(error);
        return null;
      });
  }

  async buscarPorFiltro(filtro: EquipamentoFilter): Promise<EquipamentoFilter[] | null> {
    const filtroPesquisa = { ...filtro };
    if (filtroPesquisa.cnpjPontoDeVenda !== undefined && filtroPesquisa.cnpjPontoDeVenda !== null) {
      filtroPesquisa.cnpjPontoDeVenda = Format.semPontoTracoBarra(filtroPesquisa.cnpjPontoDeVenda);
    }
    const query = queryUtil.getQuery(filtroPesquisa);
    return await instanciaAxios.get(`${equipamento}/pesquisa${query}`)
      .then((response: AxiosResponse) => {
        const lista: Array<EquipamentoFilter> = response.data;
        return lista.map((eq) => montaEndereco(eq));
      })
      .catch((error: AxiosError) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        console.error(error);
        return null;
      });
  }

  async salvar(body: EquipamentoInterface): Promise<any> {
    body.cnpjPontoDeVenda = Format.semPontoTracoBarra(body.cnpjPontoDeVenda);
    return await instanciaAxios.post(equipamento, body)
      .then((response: AxiosResponse) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Equipamento cadastrado com sucesso!');
        return response;
      })
      .catch((error: AxiosError) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        console.error(error);
      });
  }

  async atualizar(body: EquipamentoInterface): Promise<any> {
    body.cnpjPontoDeVenda = Format.semPontoTracoBarra(body.cnpjPontoDeVenda);
    return await instanciaAxios.put(`${equipamento}/${body.id}`, body)
      .then((response: AxiosResponse) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Equipamento atualizado com sucesso!');
        return response;
      })
      .catch((error: AxiosError) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        console.error(error);
      });
  }

  async alterarAtivacao(id: number, body: boolean): Promise<any> {
    return await instanciaAxios.put(`${equipamento}/alterar-ativacao/${id}`, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response: AxiosResponse) => {
      store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Ativação atualizado com sucesso!');
      return response;
    })
      .catch((error: AxiosError) => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error);
        console.error(error);
      });
  }

  async excluir(id: number): Promise<any> {
    await instanciaAxios.delete(`${equipamento}/${id}`)
      .then(() => {
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Equipamento removido com sucesso!');
      })
      .catch((error) => {
        console.error(error.response);
        store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
        return Promise.reject();
      });
  }
}
